module.exports = __webpack_public_path__ + "static/media/img3.992e7d23.jpg";